import {
  Col,
  ContactIcons,
  Container,
  FlagsIcons,
  Row,
} from "../../components";
import { useContextHook } from "../../Context/ContextOPen";
import { content } from "../../lang/useLang";
import { useEffect, useRef, useState } from "react";
import logo from "../../assets/images/1.png";

const AboutUs = () => {
  const { direction } = useContextHook();
  const [isVisible, setIsVisible] = useState(false);
  const aboutRef = useRef(null);
  const [animatedElements, setAnimatedElements] = useState({
    image: false,
    title: false,
    flags: false,
    text1: false,
    text2: false,
  });

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
          // تفعيل الأنيميشن بالتسلسل
          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, image: true })),
            200
          );
          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, title: true })),
            400
          );
          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, flags: true })),
            600
          );
          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, text1: true })),
            800
          );
          setTimeout(
            () => setAnimatedElements((prev) => ({ ...prev, text2: true })),
            1000
          );
        }
      },
      { threshold: 0.3 }
    );

    if (aboutRef.current) {
      observer.observe(aboutRef.current);
    }

    return () => {
      if (aboutRef.current) {
        observer.unobserve(aboutRef.current);
      }
    };
  }, []);

  return (
    <>
      <div
        ref={aboutRef}
        className="min-h-screen py-5 relative overflow-hidden transition-all duration-1000"
        style={{ direction }}
      >
        {/* تأثيرات الخلفية الديناميكية */}
        <div className="absolute inset-0 overflow-hidden">
          {/* أشكال هندسية عائمة */}
          <div className="absolute top-20 left-10 w-16 h-16 bg-purple-500/10 rounded-full animate-float-slow"></div>
          <div
            className="absolute top-40 right-20 w-12 h-12 bg-violet-500/10 rounded-full animate-float-medium"
            style={{ animationDelay: "2s" }}
          ></div>
          <div
            className="absolute bottom-32 left-1/4 w-20 h-20 bg-purple-500/5 rounded-full animate-float-slow"
            style={{ animationDelay: "4s" }}
          ></div>
          <div
            className="absolute bottom-20 right-32 w-14 h-14 bg-violet-500/8 rounded-full animate-float-medium"
            style={{ animationDelay: "1s" }}
          ></div>

          {/* خطوط متقاطعة */}
          <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-purple-500/20 to-transparent animate-scan-horizontal"></div>
          <div
            className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-violet-500/20 to-transparent animate-scan-horizontal"
            style={{ animationDelay: "2s" }}
          ></div>

          {/* شبكة خلفية */}
          <div className="absolute inset-0 opacity-10">
            <div
              className="absolute inset-0 bg-gradient-to-r from-purple-500/10 to-violet-500/10"
              style={{
                backgroundImage: `linear-gradient(90deg, transparent 24px, rgba(168, 85, 247, 0.1) 25px, rgba(168, 85, 247, 0.1) 26px, transparent 27px, transparent 51px, rgba(139, 92, 246, 0.1) 52px, rgba(139, 92, 246, 0.1) 53px, transparent 54px)`,
                backgroundSize: "56px 56px",
              }}
            ></div>
          </div>
        </div>

        <br />

        <Container className="relative z-10 flex items-center">
          <Row className="items-center">
            {/* الصورة مع تصميم جديد */}
            <Col
              md={5}
              className="flex justify-center items-center relative group mb-8 md:mb-0"
            >
              <div className="relative overflow-hidden rounded-3xl">
                <img
                  src={logo}
                  alt="Company Logo"
                  className="w-full h-20 object-cover transition-transform duration-1000 group-hover:scale-110"
                />
              </div>
            </Col>

            {/* المحتوى النصي */}
            <Col md={7} className="relative">
              {/* خلفية نصية زخرفية */}
              <div className="absolute -inset-6 bg-gradient-to-r from-purple-500/5 to-violet-500/5 rounded-4xl blur-2xl opacity-0 group-hover:opacity-50 transition-opacity duration-1000"></div>

              <div className="relative space-y-8 p-2">
                {/* العنوان الرئيسي */}
                <div className="space-y-4">
                  <h1
                    className={`text-6xl max-md:text-4xl font-black text-transparent bg-clip-text bg-gradient-to-r from-purple-300 via-violet-400 to-pink-300 drop-shadow-2xl transition-all duration-1000 ${
                      isVisible && animatedElements.title
                        ? "opacity-100 translate-y-0 scale-100"
                        : "opacity-0 translate-y-8 scale-95"
                    }`}
                  >
                    {content.about_us}
                  </h1>

                  <div
                    className={`text-3xl max-sm:text-xl font-bold text-white/90 logo transition-all duration-1000 delay-200 ${
                      isVisible && animatedElements.title
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-6"
                    }`}
                  >
                    {content.company}
                  </div>

                  {/* خط زخرفي */}
                  <div
                    className={`w-32 h-1.5 bg-gradient-to-r from-purple-400 to-violet-500 rounded-full shadow-lg shadow-purple-500/30 transition-all duration-1000 delay-300 ${
                      isVisible && animatedElements.title
                        ? "opacity-100 translate-x-0 scale-x-100"
                        : "opacity-0 translate-x-10 scale-x-0"
                    }`}
                  ></div>
                </div>

                {/* الأعلام مع تصميم جديد */}
                <div
                  className={`transform transition-all duration-1000 delay-400 ${
                    isVisible && animatedElements.flags
                      ? "opacity-100 translate-y-0 scale-100"
                      : "opacity-0 translate-y-8 scale-95"
                  }`}
                >
                  <FlagsIcons index={1} />
                </div>

                {/* النص مع أنيميشن متتالية */}
                <div className="space-y-6">
                  <div
                    className={`p-6 bg-white/5 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl ${
                      isVisible && animatedElements.text1
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-6"
                    }`}
                    style={{
                      transition: "all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)",
                    }}
                  >
                    <p className="text-lg leading-8 text-gray-100 font-light">
                      {content.des_about_us_one}
                    </p>
                  </div>

                  <div
                    className={`p-6 bg-white/5 rounded-2xl border border-white/10 backdrop-blur-sm hover:bg-white/10 transition-all duration-500 hover:-translate-y-1 hover:shadow-xl ${
                      isVisible && animatedElements.text2
                        ? "opacity-100 translate-y-0"
                        : "opacity-0 translate-y-6"
                    }`}
                    style={{
                      transition: "all 0.8s cubic-bezier(0.34, 1.56, 0.64, 1)",
                      transitionDelay: "200ms",
                    }}
                  >
                    <p className="text-lg leading-8 text-gray-100 font-light">
                      {content.des_about_us_tow}
                    </p>
                  </div>
                </div>

                {/* أيقونات التواصل (معلقة حالياً) */}
                <div className="transform transition-all flex justify-center duration-1000 delay-1400">
                  <ContactIcons index={1} />
                </div>
              </div>
            </Col>
          </Row>
        </Container>

        {/* الأنيميشن المخصصة */}
        <style jsx>{`
          @keyframes orbital-slow {
            0%,
            100% {
              transform: translate(0, 0) rotate(0deg) scale(1);
            }
            25% {
              transform: translate(40px, -20px) rotate(90deg) scale(1.1);
            }
            50% {
              transform: translate(0, -40px) rotate(180deg) scale(1.2);
            }
            75% {
              transform: translate(-40px, -20px) rotate(270deg) scale(1.1);
            }
          }
          @keyframes orbital-reverse {
            0%,
            100% {
              transform: translate(0, 0) rotate(0deg) scale(1);
            }
            25% {
              transform: translate(-30px, 15px) rotate(-90deg) scale(1.05);
            }
            50% {
              transform: translate(0, 30px) rotate(-180deg) scale(1.1);
            }
            75% {
              transform: translate(30px, 15px) rotate(-270deg) scale(1.05);
            }
          }
          @keyframes pulse-soft {
            0%,
            100% {
              opacity: 0.1;
              transform: scale(1);
            }
            50% {
              opacity: 0.3;
              transform: scale(1.05);
            }
          }
          @keyframes scan-horizontal {
            0% {
              transform: translateX(-100%);
            }
            100% {
              transform: translateX(100%);
            }
          }
          @keyframes twinkle-star {
            0%,
            100% {
              opacity: 0.3;
              transform: scale(1);
            }
            50% {
              opacity: 1;
              transform: scale(1.5);
              box-shadow: 0 0 20px #fff;
            }
          }
          @keyframes rotate-slow {
            from {
              transform: rotate(0deg);
            }
            to {
              transform: rotate(360deg);
            }
          }
          @keyframes rotate-reverse {
            from {
              transform: rotate(360deg);
            }
            to {
              transform: rotate(0deg);
            }
          }
          @keyframes shine {
            0% {
              transform: translateX(-100%) skewX(-12deg);
            }
            100% {
              transform: translateX(200%) skewX(-12deg);
            }
          }
          @keyframes float-slow {
            0%,
            100% {
              transform: translateY(0px) rotate(0deg);
            }
            33% {
              transform: translateY(-20px) rotate(120deg);
            }
            66% {
              transform: translateY(10px) rotate(240deg);
            }
          }
          @keyframes float-medium {
            0%,
            100% {
              transform: translateY(0px) rotate(0deg);
            }
            33% {
              transform: translateY(-15px) rotate(-120deg);
            }
            66% {
              transform: translateY(8px) rotate(-240deg);
            }
          }
          @keyframes glow-border {
            0% {
              border-color: transparent;
              box-shadow: 0 0 0 0 rgba(168, 85, 247, 0.7);
            }
            50% {
              border-color: rgba(168, 85, 247, 0.5);
              box-shadow: 0 0 0 10px rgba(168, 85, 247, 0);
            }
            100% {
              border-color: transparent;
              box-shadow: 0 0 0 0 rgba(168, 85, 247, 0);
            }
          }
          .animate-orbital-slow {
            animation: orbital-slow 25s ease-in-out infinite;
          }
          .animate-orbital-reverse {
            animation: orbital-reverse 30s ease-in-out infinite;
          }
          .animate-pulse-soft {
            animation: pulse-soft 6s ease-in-out infinite;
          }
          .animate-scan-horizontal {
            animation: scan-horizontal 4s linear infinite;
          }
          .animate-twinkle-star {
            animation: twinkle-star 3s ease-in-out infinite;
          }
          .animate-rotate-slow {
            animation: rotate-slow 20s linear infinite;
          }
          .animate-rotate-reverse {
            animation: rotate-reverse 25s linear infinite;
          }
          .animate-shine {
            animation: shine 3s ease-in-out;
          }
          .animate-float-slow {
            animation: float-slow 8s ease-in-out infinite;
          }
          .animate-float-medium {
            animation: float-medium 6s ease-in-out infinite;
          }
          .animate-glow-border {
            animation: glow-border 2s ease-in-out;
          }
        `}</style>
      </div>
    </>
  );
};

export default AboutUs;
